import classes from './SuperScript.module.scss'
import type { ReactNode } from 'react'
import type { SuperScriptVariant } from '@eggplant/types'

export interface Props {
  children: ReactNode
  value: string
  variant?: SuperScriptVariant
}

const SuperScript = ({
  children,
  value,
  variant = 'purple'
}: Props) => {
  const isNumber = !isNaN(parseFloat(value))

  const baseClass = isNumber
    ? classes.NumberCircle
    : classes.IconCircle

  const childClass = [
    baseClass,
    classes[variant]
  ].filter(wrapper => wrapper).join(' ')

  return (
    <span className={classes.SuperScript}>
      {
        value &&
          <span
            aria-label='Superscript number'
            className={childClass}
          >
            {value}
          </span>
      }
      {children}
    </span>

  )
}

export default SuperScript
